export const GET_ALL_BANNER_REQUEST = "GET_ALL_BANNER_REQUEST";
export const GET_ALL_BANNER_FAILURE = "GET_ALL_BANNER_FAILURE";
export const GET_ALL_BANNER_SUCCESS = "GET_ALL_BANNER_SUCCESS";

